angular
  .module('contrast.services.attack.monitor', [])
  .factory(
    'AttackMonitorService',
    function (
      $translate,
      TimeService,
      ErrorService,
      AttackMonitorFactory,
      SERVER_ENVIRONMENT_SELECT,
      SERVER_ENVIRONMENT_ENUM,
      APPLICATION_IMPORTANCE_ENUM,
      ATTACK_MONITOR_FILTER_GROUPS,
      RULE_SEVERITY_ENUM,
      UNKNOWN_SOURCE_KEY
    ) {
      'ngInject'

      var defaultFilters = {
          selected: [],
          environmentFilters: getEnvironmentFilters(),
          environments: SERVER_ENVIRONMENT_SELECT,
          environment: SERVER_ENVIRONMENT_SELECT[0],
          availableFilters: [],
          probed: true,
          date: {
            startDate: null,
            endDate: null,
            label: 'Last day'
          }
        },
        _filters = angular.copy(defaultFilters)

      return {
        filters: monitorFiltersGetterSetter,

        getAttackTraffic: getAttackTraffic,
        getStats: getStats,
        getFilters: getFilters,
        getAttackers: getAttackers,
        getEvents: getEvents,
        getApps: getApps,
        eventsClassAccessor: eventsClassAccessor
      }

      function monitorFiltersGetterSetter(newFilters) {
        if (!arguments.length) {
          return _filters
        }

        if (!newFilters) {
          _filters = angular.copy(defaultFilters)
        }

        return _filters
      }

      function getAttackTraffic() {
        return AttackMonitorFactory.getTimeline().then(function (response) {
          return response.data
        })
      }

      function getStats() {
        return AttackMonitorFactory.getStats().then(function (response) {
          var data = response.data

          return {
            protect:
              data.totalProductionServers > 0
                ? Math.floor(
                    (data.serversProtected / data.totalProductionServers) * 100
                  )
                : null,
            apps: data.apps,
            servers: data.servers,
            highRiskApps: data.highRiskApps,
            protectedApps: data.protectedApps,
            protected:
              data.totalProductionApps > 0
                ? Math.floor(
                    (data.protectedApps / data.totalProductionApps) * 100
                  )
                : null,
            productionApps: data.totalProductionApps,
            requestsPerSecond: data.requestsPerSecond
          }
        }, ErrorService.processError)
      }

      function getFilters(filters) {
        var form = transformFilterForm(filters, true)
        return AttackMonitorFactory.getFilters(form).then(function (response) {
          return transformFilterResults(response.data)
        }, ErrorService.processError)
      }

      function getAttackers(filters, oldResults, ignoreSubfilters) {
        var form = transformFilterForm(filters, ignoreSubfilters)

        return AttackMonitorFactory.getTopAttackers(form).then(function (
          response
        ) {
          var data = response.data

          if (oldResults) {
            var i = 0,
              oldAttacker = null,
              exists
            for (; i < oldResults.attackers.length; i++) {
              oldAttacker = oldResults.attackers[i]

              exists = data.attackers.find(function (attacker) {
                return attacker.attacker == oldAttacker.attacker
              })

              oldAttacker.disabled = !exists
            }

            oldResults.total = data.total
            oldResults.count =
              data.attackers.length + data.remaining_attackers.length

            if (oldResults.remaining_breakdown) {
              var oldAttackerName = '',
                hasRemaining = false
              for (i = 0; i < oldResults.remaining_attackers.length; i++) {
                oldAttackerName = oldResults.remaining_attackers[i]

                exists = data.attackers.find(function (item) {
                  return item.attacker == oldAttackerName
                })

                if (exists) {
                  hasRemaining = true
                  if (!data.remaining_breakdown) {
                    data.remaining_breakdown = exists
                  } else {
                    data.remaining_breakdown.exploited_attacks +=
                      exists.exploited_attacks
                    data.remaining_breakdown.probed_attacks +=
                      exists.probed_attacks
                    data.remaining_breakdown.blocked_attacks +=
                      exists.blocked_attacks
                    data.remaining_breakdown.suspicious_attacks +=
                      exists.suspicious_attacks
                    data.remaining_breakdown.total_attacks +=
                      exists.total_attacks
                  }
                  data.remaining_attackers.push(oldAttackerName)
                }
              }

              if (hasRemaining) {
                oldResults.remaining_breakdown = data.remaining_breakdown
                oldResults.remaining_attackers = data.remaining_attackers
                oldResults.remaining_breakdown.disabled = false
              } else if (!hasRemaining && !data.remaining_breakdown) {
                oldResults.remaining_breakdown.disabled = true
              }
            }

            return oldResults
          } else {
            data.count = data.attackers.length + data.remaining_attackers.length
          }

          return data
        },
        ErrorService.processError)
      }

      function getEvents(filters, oldResults, ignoreSubfilters) {
        var form = transformFilterForm(filters, ignoreSubfilters)

        return AttackMonitorFactory.getTopEvents(form).then(function (
          response
        ) {
          var data = response.data
          transformEventItems(data)

          if (oldResults) {
            var i = 0,
              oldItem = null,
              exists
            for (; i < oldResults.items.length; i++) {
              oldItem = oldResults.items[i]

              exists = data.items.find(function (item) {
                return item.rule_uuid == oldItem.rule_uuid
              })

              if (exists) {
                oldResults.items[i] = exists
              } else {
                oldItem.disabled = true
              }
            }

            if (oldResults.remaining_breakdown) {
              var oldEventName = '',
                hasRemaining = false
              for (i = 0; i < oldResults.remaining_events.length; i++) {
                oldEventName = oldResults.remaining_events[i]

                exists = data.items.find(function (item) {
                  return item.event == oldEventName
                })

                if (exists) {
                  hasRemaining = true
                  if (!data.remaining_breakdown) {
                    data.remaining_breakdown = exists
                  } else {
                    data.remaining_breakdown.exploited_attacks +=
                      exists.exploited_attacks
                    data.remaining_breakdown.probed_attacks +=
                      exists.probed_attacks
                    data.remaining_breakdown.blocked_attacks +=
                      exists.blocked_attacks
                    data.remaining_breakdown.suspicious_attacks +=
                      exists.suspicious_attacks
                    data.remaining_breakdown.total_attacks +=
                      exists.total_attacks
                  }
                  data.remaining_events.push(oldEventName)
                }
              }

              if (hasRemaining) {
                setItemData(data.remaining_breakdown, data.totalAttacks)
              } else if (!data.remaining_breakdown) {
                data.remaining_breakdown = oldResults.remaining_breakdown
                data.remaining_breakdown.disabled = true
              }
            }

            data.items = oldResults.items
          }

          return data
        },
        ErrorService.processError)
      }

      function getApps(filters, oldResults, ignoreSubfilters) {
        var form = transformFilterForm(filters, ignoreSubfilters)

        return AttackMonitorFactory.getTopTargetedApps(form).then(function (
          response
        ) {
          var data = response.data
          transformEventItems(data, true)

          if (oldResults) {
            var i = 0,
              oldItem = null,
              exists
            for (; i < oldResults.items.length; i++) {
              oldItem = oldResults.items[i]

              exists = data.items.find(function (item) {
                return item.app_id == oldItem.app_id
              })

              if (exists) {
                oldResults.items[i] = exists
              } else {
                oldItem.disabled = true
              }
            }

            if (oldResults.remaining_breakdown) {
              var oldAppName = '',
                hasRemaining = false
              for (i = 0; i < oldResults.remaining_applications.length; i++) {
                oldAppName = oldResults.remaining_applications[i]

                exists = data.items.find(function (item) {
                  return item.application == oldAppName
                })

                if (exists) {
                  hasRemaining = true
                  if (!data.remaining_breakdown) {
                    data.remaining_breakdown = exists
                  } else {
                    data.remaining_breakdown.exploited_attacks +=
                      exists.exploited_attacks
                    data.remaining_breakdown.probed_attacks +=
                      exists.probed_attacks
                    data.remaining_breakdown.blocked_attacks +=
                      exists.blocked_attacks
                    data.remaining_breakdown.suspicious_attacks +=
                      exists.suspicious_attacks
                    data.remaining_breakdown.total_attacks +=
                      exists.total_attacks
                  }
                  data.remaining_applications.push(oldAppName)
                }
              }

              if (hasRemaining) {
                setItemData(data.remaining_breakdown, data.totalAttacks)
              } else if (!data.remaining_breakdown) {
                data.remaining_breakdown = oldResults.remaining_breakdown
                data.remaining_breakdown.disabled = true
              }
            }

            data.items = oldResults.items
          }

          return data
        },
        ErrorService.processError)
      }

      function transformFilterForm(form, ignoreSecondaryFilters) {
        var filterForm = {
          startDate: null,
          endDate: null,
          environments: SERVER_ENVIRONMENT_ENUM,
          probed: form.probed,
          live: false,

          //Secondary Filters
          applicationIds: [],
          ruleUuids: [],
          ruleSeverities: [],
          attackers: []
        }
        // this matches the Attacks grid date logic
        // scripts/custom/components/attacks/attacks.controller.js-567
        if (form.date) {
          var format = TimeService.getDateTimeFormat()
          if (form.date.startDate) {
            filterForm.startDate = TimeService.getTimeInUserTimeZone(
              moment(form.date.startDate, format).valueOf()
            )
          }

          if (form.date.endDate) {
            filterForm.endDate = TimeService.getTimeInUserTimeZone(
              moment(form.date.endDate, format).valueOf()
            )
          }

          if (form.date.label == 'Live') {
            filterForm.live = true
          }
        }

        if (form.environment.value != 'ALL') {
          filterForm.environments = [form.environment.value]
        }

        if (!ignoreSecondaryFilters) {
          var i = 0,
            item = null
          for (; i < form.selected.length; i++) {
            item = form.selected[i]

            // TODO: CONTRAST-18297
            // eslint-disable-next-line default-case
            switch (item.group) {
              case ATTACK_MONITOR_FILTER_GROUPS.ATTACKERS:
                filterForm.attackers.push(item.value)
                break

              case ATTACK_MONITOR_FILTER_GROUPS.RULES:
                if (item.isSeverity) {
                  filterForm.ruleSeverities.push(item.value)
                } else {
                  filterForm.ruleUuids.push(item.value)
                }
                break

              case ATTACK_MONITOR_FILTER_GROUPS.APPLICATIONS:
                filterForm.applicationIds.push(item.value)
                break
            }
          }
        }

        return filterForm
      }

      function transformFilterResults(data) {
        var results = [],
          i = 0

        for (; i < data.attackers.length; i++) {
          var name =
            data.attackers[i] === UNKNOWN_SOURCE_KEY
              ? $translate.instant('detail_attacks_unknown_source')
              : data.attackers[i]
          results.push({
            group: ATTACK_MONITOR_FILTER_GROUPS.ATTACKERS,
            name: name,
            value: data.attackers[i]
          })
        }

        for (i = 0; i < data.rule_severities.length; i++) {
          results.push({
            group: ATTACK_MONITOR_FILTER_GROUPS.RULES,
            name: RULE_SEVERITY_ENUM[data.rule_severities[i]],
            value: data.rule_severities[i],
            isSeverity: true
          })
        }

        for (i = 0; i < data.rules.length; i++) {
          results.push({
            group: ATTACK_MONITOR_FILTER_GROUPS.RULES,
            name: data.rules[i].name,
            value: data.rules[i].id,
            isSeverity: false
          })
        }

        for (i = 0; i < data.applications.length; i++) {
          results.push({
            group: ATTACK_MONITOR_FILTER_GROUPS.APPLICATIONS,
            name: data.applications[i].name,
            value: data.applications[i].id
          })
        }

        return results
      }

      function transformEventItems(data, isApps) {
        var totalAttacks = data.items.reduce(function (total, item) {
          return total + item.total_attacks
        }, 0)

        if (data.remaining_breakdown) {
          totalAttacks += data.remaining_breakdown.total_attacks
          setItemData(data.remaining_breakdown, totalAttacks)
        }

        data.totalAttacks = totalAttacks

        for (var i = 0; i < data.items.length; i++) {
          var item = data.items[i]

          setItemData(item, totalAttacks)
          if (isApps) {
            item.importance = $translate.instant(
              APPLICATION_IMPORTANCE_ENUM[item.importance]
            )
          }
        }
      }

      function setItemData(item, totalAttacks) {
        item.data = []

        if (item.exploited_attacks) {
          item.data.push({
            name: 'EXPLOITED',
            value: item.exploited_attacks
          })
        }

        if (item.blocked_attacks) {
          item.data.push({
            name: 'BLOCKED',
            value: item.blocked_attacks
          })
        }

        if (item.suspicious_attacks) {
          item.data.push({
            name: 'SUSPICIOUS',
            value: item.suspicious_attacks
          })
        }

        if (item.probed_attacks) {
          item.data.push({
            name: 'PROBED',
            value: item.probed_attacks
          })
        }

        item.percent =
          totalAttacks == 0
            ? 0
            : ((item.total_attacks / totalAttacks) * 100).toFixed(2)
      }

      function eventsClassAccessor(attack) {
        // TODO: CONTRAST-18297
        // eslint-disable-next-line default-case
        switch (attack.name) {
          case 'EXPLOITED':
            return 'thermometer-red'
          case 'BLOCKED':
            return 'thermometer-green'
          case 'SUSPICIOUS':
            return 'thermometer-yellow'
          case 'PROBED':
            return 'thermometer-gray'
        }
        return ''
      }

      function getEnvironmentFilters() {
        return SERVER_ENVIRONMENT_SELECT.reduce(function (result, current) {
          result[current.value] = []
          return result
        }, {})
      }
    }
  )
